// ATE-CR-117 — task 11 FIX: align EscalationListItem to real backend EscalationItem
// shape (services/dashboard_api/.../api/schemas/escalation.py). Backend returns
// paginated `{total, items, page, page_size}` envelope; unwrap to keep
// callers' `EscalationListItem[]` contract.
import { fetchApi } from "@/api/client";

export const API_ESCALATIONS_PATH = "/api/escalations" as const;

// ATE-CR-117 — Mirrors backend `EscalationItem`. Field names/types match the
// FastAPI schema exactly so payloads decode without runtime massaging.
export interface EscalationListItem {
  readonly request_id: string;
  readonly tenant_id: string;
  readonly request_type: string;
  readonly status: string;
  readonly held_amount: number;
  readonly held_resource: string;
  readonly held_source: string;
  readonly held_expires_at: string; // ISO
  readonly escalated_at: string; // ISO
}

export type EscalationResolution = "commit" | "release";

// ATE-CR-117 — backend list envelope for /api/escalations.
interface EscalationsListResponse {
  readonly total: number;
  readonly items: EscalationListItem[];
  readonly page: number;
  readonly page_size: number;
}

// ATE-CR-117 — task 11 FIX: unwrap paginated envelope.
export async function listEscalations(signal?: AbortSignal): Promise<EscalationListItem[]> {
  const response = await fetchApi<EscalationsListResponse>(API_ESCALATIONS_PATH, { signal });
  return response.items;
}

// ATE-CR-117
export async function resolveEscalation(
  requestId: string,
  body: { resolution: EscalationResolution; note?: string },
  signal?: AbortSignal,
): Promise<void> {
  await fetchApi<void>(`${API_ESCALATIONS_PATH}/${encodeURIComponent(requestId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
    signal,
  });
}
